<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{'DENY_DIALOG.TITLE' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div class="row container-fluid padding-right-0">
    <div class="col-md-12 padding-right-0">
        <mat-dialog-content class="contentPadding">
            <div class="dialogMessage">
                <p>{{'DENY_DIALOG.MESSAGE' | translate}}</p>
            </div>
            <div>
                <!-- <mat-form-field> -->
                <textarea type="textarea" class="textareaStyle" matInputAutofocus matInput for="denySection" rows="5"
                    [formControl]="denySection"></textarea>
                <!-- </mat-form-field> -->
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="actionsPadding">
            <button class="openCloseBtn" mat-raised-button mat-dialog-close color="primary"
                (click)="OnConfirmClick()">{{'COMMON_DIALOGS_BTN_LABELS.OK' | translate}}</button>
            <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>{{'COMMON_DIALOGS_BTN_LABELS.CANCEL' | translate}}</button>
        </mat-dialog-actions>
    </div>
</div>